import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressChallengeTargetSuccessApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-challenge-target-success.application-service';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressChallengeTargetSuccessQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressChallengeTargetSuccessApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<number> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
